module.exports = __webpack_public_path__ + "static/img/pdf.e64b6aad.png";